import { render, staticRenderFns } from "./ItemEmbedCode.vue?vue&type=template&id=5ffd884f&"
import script from "./ItemEmbedCode.vue?vue&type=script&lang=js&"
export * from "./ItemEmbedCode.vue?vue&type=script&lang=js&"
import style0 from "./ItemEmbedCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports